module.exports = __webpack_public_path__ + "assets/assets/images/home/login.b7cb417a.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/home/login.png
// module id = 476
// module chunks = 0